import { or, pathOr } from "ramda"

import { INDEXES } from "../constants/indexes"
import { ResultType } from "../constants/resultType"
import { ServiceConfig, ServicesConfig } from "../typings/ServicesConfig"

export function isTrue(value: string | null | boolean) {
  if (typeof value === "boolean") return value
  return value === "true"
}

export function parseServicesConfigFromPostMessage(
  config?: ServicesConfig,
): ServicesConfig {
  const defaultServicesPosition = INDEXES

  const defaultServiceConfig = {
    show: pathOr(true, ["default", "show"], config),
    showAds: pathOr(true, ["default", "showAds"], config),
    filter: pathOr("", ["default", "filter"], config),
    showHotResults: pathOr(true, ["default", "showHotResults"], config),
  }

  const defaultSearchInputConfig = {
    placeholder: "搜尋香港01",
  }

  const configGetter = (
    path: string[],
    defaultConfig = defaultServiceConfig,
  ) => {
    return {
      show: pathOr(defaultConfig.show, [...path, "show"], config),
      showAds: pathOr(defaultConfig.showAds, [...path, "showAds"], config),
      filter: pathOr(defaultConfig.filter, [...path, "filter"], config),
      showHotResults: pathOr(
        defaultConfig.showHotResults,
        [...path, "showHotResults"],
        config,
      ),
    }
  }

  const getServices = ({ forAllTab }: { forAllTab: boolean }) =>
    Object.fromEntries<ServiceConfig>(
      Object.values(ResultType)
        .filter((type) => type !== ResultType.ALL)
        .map((type) => [
          type,
          configGetter(
            forAllTab
              ? ["services", ResultType.ALL, "services", type]
              : ["services", type],
            defaultServiceConfig,
          ),
        ]),
    ) as { [P in Exclude<ResultType, ResultType.ALL>]: ServiceConfig }

  return {
    searchInput: { ...defaultSearchInputConfig, ...config?.searchInput },
    default: defaultServiceConfig,
    servicesPosition: pathOr(
      defaultServicesPosition,
      ["servicesPosition"],
      config,
    ),
    services: {
      ...getServices({ forAllTab: false }),
      [ResultType.ALL]: {
        ...configGetter(["services", ResultType.ALL], defaultServiceConfig),
        servicesPosition: pathOr(
          defaultServicesPosition,
          ["services", ResultType.ALL, "servicesPosition"],
          config,
        ),
        services: getServices({ forAllTab: true }),
      },
    },
  }
}

export function parseQueryStringFromURL(url: string) {
  const { searchParams } = new URL(url)
  const gaTrackingId = searchParams.getAll("gaTrackingId")
  return {
    searching: {
      defaultQuery: or(searchParams.get("defaultQuery"), "") as string,
      title: or(searchParams.get("title"), "") as string,
    },
    trackerConfig: {
      GA: {
        trackingId: gaTrackingId.length !== 0 ? gaTrackingId : "UA-70981149-9",
      },
      Piwik: {
        trackingUrl: or(
          searchParams.get("piwikTrackingUrl"),
          "https://track.hktester.com/v2/piwik.php",
        ),
        siteId: parseInt(
          or(searchParams.get("piwikSiteId"), "5") as string,
          10,
        ),
        userId: or(searchParams.get("piwikUserId"), "empty"),
      },
      webviewBridgeEnabled: false,
    },
    trackingParameter: {
      account_id: searchParams.get("accountId"),
      anonymous_id: searchParams.get("anonymousId"),
      bucket_id: searchParams.get("bucketId"),
      source: searchParams.get("source"),
      session_id: searchParams.get("sessionId"),
    },
  }
}
